import {apolloClient, gql} from '../graphql';
import {type PaymentAccount} from 'shared/src/models';

export const getPaymentAccounts = async (): Promise<PaymentAccount[]> => {
	const {data, error} = await apolloClient.query({
		query: gql(/* GraphQL */ `
			query GetPaymentAccounts {
				accounts {
					id
					type
					name
					balance
					closed
				}
			}
		`),
		fetchPolicy: 'no-cache',
	});

	if (error) {
		throw error;
	}

	return data.accounts;
};
